export default __webpack_public_path__ + "static/panbox_virus_splatter-52d85db27dcfe5227255c26ace8723d2.png";